import React, { useState, useEffect } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import BoxWrapper from "../../components/ui/boxWrapper";
import "../MDM/mdm.css";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "../../axios-order";
import moment from "moment";
import DatePicker from "../../components/ui/DatePicker";
import { ValidatorForm } from "react-material-ui-form-validator";
import { toast } from "react-toastify";
import { Grid } from "@material-ui/core";
import { Typography, Select, MenuItem, Button } from "@mui/material";
import SelectField from "../../components/ui/basicSelectInput";
import { canRead, canWrite } from "../../utils/privilegeUtils";

const MSME = () => {
  const [mdmType, setMdmType] = useState("customers");
  const [tableData, setTableData] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [financialYear, setFinancialYear] = useState("");
  const [table, setTable] = useState([]);
  const [isRefreshingForm, setIsRefreshingForm] = useState(false);

  const [triggerAsOfDate, setTriggerAsOfDate] = useState(false);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [triggerDate, setTriggerDate] = useState(false);

  const mdmChangeHandler = (e) => {
    const { value } = e.target;
    setMdmType(value);
  };

  const handlePeriodChange = (e) => {
    setSelectedPeriod(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleClear = () => {
    if (mdmType === "form") {
      setSelectedPeriod("");
      setSelectedYear("");
      setFinancialYear("");
    } else {
      setMdmType("");
      setTriggerAsOfDate(false);
      setFromDate(null);
      setToDate(null);
      setTriggerDate(false);
    }
  };



  const handleSubmit = () => {
    const businessEntityId = localStorage.getItem("business_entity_id");
    let changeInDate = {};
    if (!businessEntityId) {
      toast.error("Business entity ID not found.", {
        autoClose: 3000,
        progress: 0,
      });
      return;
    }

    // if (!financialYear) {
    //   toast.error("Please select financial year.", {
    //     autoClose: 3000,
    //     progress: 0,
    //   });
    //   return;
    // }

    if (!selectedPeriod) {
      toast.error("Please select period.", {
        autoClose: 3000,
        progress: 0,
      });
      return;
    }

    // const [startYear, endYear] = financialYear.split('-').map(y => parseInt(y));
    // let fromDate, toDate;

    // if (selectedPeriod === "apr-sep") {
    //   fromDate = `${startYear}-04-01`;
    //   toDate = `${startYear + 1}-09-30`;
    // } else {
    //   fromDate = `${startYear}-10-01`;
    //   toDate = `${startYear + 1}-03-31`;
    // }

    changeInDate = {
      business_entity_id: businessEntityId,
      financial_year: financialYear,
      period: selectedPeriod,
    };
    axios
      .post(`/msme_form_upload_asy`, changeInDate)
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success(res?.data?.message, {
            autoClose: 3000,
            progress: 0,
          });
          getMsmeForm1Api();
          setFinancialYear("");
          setSelectedPeriod("");
          changeInDate = {};
        } else {
          toast.error(res?.data?.message, {
            autoClose: 3000,
            progress: 0,
          });
        }
      })
      .catch((e) => {
        changeInDate = {};
        toast.error(e?.response?.data?.message, {
          autoClose: 3000,
          progress: 0,
        });
      });
  };

  const mdmFormSubmitHandler = () => {

    let changeInDate = {};

    if (mdmType === "" ) {
      toast.error("MSME type is mandatory filed", {
        autoClose: 3000,
        progress: 0,
      });
    } else if(triggerDate === false && triggerAsOfDate === false ) {
      toast.error("Date are mandatory filed", {
        autoClose: 3000,
        progress: 0,
      });
    } else {

      if (triggerAsOfDate) {
        changeInDate = {
          as_of_date: true,
        };
      } else {
        changeInDate = {
          from_date: moment(fromDate).format("YYYY-MM-DD"),
          to_date: moment(toDate).format("YYYY-MM-DD"),
        };
      }

      axios
        .post(`/msme_recon/report`, {
          bid: localStorage.getItem("business_entity_id"),
          msme_type: mdmType,
          ...changeInDate,
        })
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(res?.data?.Message, {
              autoClose: 3000,
              progress: 0,
            });
            getApi();
            setMdmType("");
            changeInDate = {};
            setTriggerAsOfDate(false);
            setFromDate(null);
            setToDate(null);
            setTriggerDate(false);
          } else {
            toast.error(res?.data?.Message, {
              autoClose: 3000,
              progress: 0,
            });
          }
        })
        .catch((e) => {
          changeInDate = {};
          toast.error(e?.response?.data?.message, {
            autoClose: 3000,
            progress: 0,
          });
        });
    }
  };

  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const downloadMDMHandler = (jsonData, msme_type) => {
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `MSME Summary`;

    axios
      .post(`msme/download`, {
        data: jsonData,
        bid: localStorage.getItem("business_entity_id"),
        cust_msme_flag: msme_type === "CUSTOMER" ? true : false,
      })
      .then((res) => {
        if (res?.data?.status === "fail") {
          alert(res?.data?.message);
        } else if (res?.data?.status === "pass") {
          downloadBase64File(contentType, res?.data?.file, filename);
        }
      })
      .catch((e) => {
        alert("Unable To Download Please Try Again");
      });
  };

  const downloadReport = (summary_id) => {
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `MSME Summary`;

    axios
      .post(`/generate_msme_excel_report`, {
        business_entity_id: localStorage.getItem("business_entity_id"),
        summary_id: summary_id,
      })
      .then((res) => {
        if (res?.data?.status === "fail") {
          alert(res?.data?.message);
        } else if (res?.data?.status === "pass") {
          downloadBase64File(contentType, res?.data?.file, filename);
        }
      })
      .catch((e) => {
        alert("Unable To Download Please Try Again");
      });
  };

  const yearArr = (() => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear - 5; i <= currentYear; i++) {
      const endYear = (i + 1).toString().slice(-2);
      years.push({ id: `${i}-${endYear}`, value: `${i}-${endYear}` });
    }
    return years;
  })();

  const getApi = () => {
    axios
      .get(`/msme_log/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data.status === true) {
          setTableData(res?.data?.records);
        } else {
          setTableData([]);
        }
      })
      .catch((e) => {
        setTableData([]);
        alert(e.response.data.message);
      });
  };

  useEffect(() => {
    getApi();
  }, []);

  const getMsmeForm1Api = () => {
    setIsRefreshingForm(true);
    axios
      .get(`/get_msme_form_summary_logs/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data.status === true) {
          setTable(res?.data?.data);
        } else {
          setTable([]);
        }
        setIsRefreshingForm(false);
      })
      .catch((e) => {
        setTable([]);
        // alert(e.response.data.message);
      });
  };

  useEffect(() => {
    getMsmeForm1Api();
  }, []);

  return (
    <>
      <FormControl>
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="mdmType"
          value={mdmType ?? ""}
          onChange={mdmChangeHandler}
        >
          <FormControlLabel
            value="customers"
            control={<Radio />}
            label="Customers MSME"
          />
          <FormControlLabel
            value="vendors"
            control={<Radio />}
            label="Vendors MSME"
          />
          <FormControlLabel
            value="form"
            control={<Radio />}
            label="MSME Form 1"
          />
        </RadioGroup>
      </FormControl>

      {/* form - Show customers/vendors filter by default when no radio is selected */}
      {mdmType === "" || mdmType === "customers" || mdmType === "vendors" ? (
        <BoxWrapper boxTitle="Filter">
          <div className="mdm-form">
            <Grid container spacing={1}>
              <Grid item lg={3}>
                <label>As of Date:</label> <br />
                <button
                  style={
                    triggerAsOfDate === false
                      ? {
                        width: "100%",
                        padding: "7px 15px",
                      }
                      : {
                        width: "90%",
                        background: "rgb(208, 70, 70)",
                        padding: "7px 15px",
                        color: "#fff",
                      }
                  }
                  className="button-outlined-primary"
                  disabled={triggerDate === false ? false : true}
                  onClick={() => setTriggerAsOfDate(!triggerAsOfDate)}
                >
                  {triggerAsOfDate
                    ? "selected"
                    : triggerDate
                      ? "Disabled"
                      : "As of Date"}
                </button>
              </Grid>
              <Grid item lg={9}>
                <ValidatorForm
                  useRef="form"
                  // onSubmit={onSubmitHandler}
                  onError={(errors) => console.log(errors)}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={6}>
                      <label>From Date:</label>
                      <DatePicker
                        placeholder={
                          triggerAsOfDate === false ? "From Date" : "Disabled"
                        }
                        errorMessages={["This field is required"]}
                        validators={["required"]}
                        disabled={triggerAsOfDate === false ? false : true}
                        value={fromDate ?? ""}
                        onChange={(v) => {
                          setFromDate(v);
                          setTriggerDate(true);
                        }}
                      />
                    </Grid>
                    <Grid item lg={6}>
                      <label>To Date:</label>
                      <DatePicker
                        placeholder={
                          triggerAsOfDate === false ? "To Date" : "Disabled"
                        }
                        errorMessages={["This field is required"]}
                        disabled={triggerAsOfDate === false ? false : true}
                        validators={["required"]}
                        value={toDate ?? ""}
                        onChange={(v) => {
                          setToDate(v);
                          setTriggerDate(true);
                        }}
                      />
                    </Grid>
                  </Grid>
                </ValidatorForm>
              </Grid>
            </Grid>

            <div>
              <div>
              {canWrite("MSME") && (
              <button
                className="button-outlined-primary"
                onClick={mdmFormSubmitHandler}
                style={{ marginTop: "25px", marginLeft: "20px" }}
              >
                Submit
              </button>
              )}
            </div>
            </div>
            <div>
              <button
                type="button"
                className="button-outlined-secondary"
                style={{ marginTop: "25px", marginLeft: "10px" }}
                onClick={handleClear}
              >
                Clear
              </button>
            </div>
          </div>
        </BoxWrapper>
      ) : null}

      {/* MSME Form BoxWrapper */}
      {mdmType === "form" && canWrite("MSME") && (
        <ValidatorForm
          onSubmit={handleSubmit}
        >
          <BoxWrapper boxTitle="Filter">
            <div className="mdm-form">
              <Grid container spacing={1} alignItems="center" justifyContent="center">
                <Grid item lg={3}>
                  <label>Financial Year:<span style={{ color: "red", marginLeft: "2px" }}>*</span></label>
                  <FormControl fullWidth required>
                    <Select
                      value={financialYear}
                      onChange={(e) => setFinancialYear(e.target.value)}
                      validators={["required"]}
                      errorMessages={["This field is required"]}
                      style={{ height: "40px" }}
                    >
                      {yearArr.map((year) => (
                        <MenuItem key={year.id} value={year.id}>
                          {year.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={4} style={{ paddingLeft: "50px" }}>
                  <label style={{ marginTop: "0px" }}>Period:<span style={{ color: "red", marginLeft: "2px" }}>*</span></label>
                  <RadioGroup
                    row
                    name="period"
                    value={selectedPeriod}
                    onChange={handlePeriodChange}
                    validators={["required"]}
                    errorMessages={["This field is required"]}
                    style={{ marginTop: "-5px", marginLeft: "-11px" }}
                  >
                    <FormControlLabel
                      value="apr-sep"
                      control={<Radio />}
                      label="Apr to Sep"
                      labelPlacement="end"
                      style={{ margin: 0, whiteSpace: "nowrap" }}
                    />
                    <FormControlLabel
                      value="oct-mar"
                      control={<Radio />}
                      label="Oct to Mar"
                      labelPlacement="end"
                      style={{ margin: 0, whiteSpace: "nowrap" }}
                    />
                  </RadioGroup>
                </Grid>
                <Grid item lg={2} style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginTop: "25px" }}>
                  <button
                    className="button-outlined-primary"
                    type="submit"
                    style={{ marginRight: "10px" }}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="button-outlined-secondary"
                    style={{ padding: "7px 15px", width: "auto" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                </Grid>
              </Grid>
            </div>
          </BoxWrapper>
        </ValidatorForm>
      )}
      {/* history table */}
      {(mdmType === "" || mdmType === "customers" || mdmType === "vendors") && (
        <BoxWrapper
          boxTitle="MSME History"
          enableAddButton={true}
          addButtonLabel="Refresh"
          addButtonHandlerFn={getApi}
        >
          <div className="responsive-table">
            <table className="custome-table">
              <thead>
                <tr>
                  <th>MSME Type</th>
                  <th>Created date & time</th>
                  <th>Status</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {tableData?.length > 0 ? (
                  tableData.map((item, i) => (
                    <tr key={`${i}mdm`}>
                      <td>{item?.msme_type}</td>
                      <td>{moment(item?.created_date).format("DD/MM/YYYY, h:mm:ss a")}</td>
                      <td>{item?.status}</td>
                      <td>
                        {item?.status === "Pass" ? (
                          <DownloadIcon
                            className="action-icon-button showIcon"
                            onClick={() =>
                              downloadMDMHandler(item?.msme_log?.inv_records, item?.msme_type)
                            }
                          />
                        ) : item?.status === "Fail" ? (
                          <DownloadIcon
                            className="action-icon-button showIcon"
                            style={{ color: "red" }}
                            onClick={() => alert(item?.error?.error)}
                          />
                        ) : (
                          <DownloadIcon
                            className="action-icon-button showIcon"
                            style={{ color: "#ddd" }}
                          />
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} style={{ textAlign: "center", color: "red" }}>
                      No Data Found!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </BoxWrapper>
      )}
      {/* MSME Form 1 History Table */}
      {mdmType === "form" && (
        <BoxWrapper
          boxTitle="MSME History"
          enableAddButton={true}
          addButtonLabel={isRefreshingForm ? "Loading..." : "Refresh"}
          addButtonHandlerFn={getMsmeForm1Api}
          addButtonDisabled={isRefreshingForm}
        >
          <div className="responsive-table">
            <table className="custome-table">
              <thead>
                <tr>
                  <th>MSME Type</th>
                  <th>Created date & time</th>
                  <th>Status</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {table?.length > 0 ? (
                  table.map((item, i) => (
                    <tr key={`${i}form`}>
                      <td>{item?.msme_type}</td>
                      <td>{item?.created_datetime}</td>
                      <td>{item?.status}</td>
                      <td>
                        {item?.status === "Completed" ? (
                          <DownloadIcon
                            className="action-icon-button showIcon"
                            onClick={() => downloadReport(item?.summary_id)}
                          />
                        ) : item?.status === "Failed" ? (
                          <DownloadIcon
                            className="action-icon-button showIcon"
                            style={{ color: "#ddd" }}
                            onClick={() => alert("No Records Found")}
                          />
                        ) : (
                          <DownloadIcon
                            className="action-icon-button showIcon"
                            style={{ color: "#ddd" }}
                          />
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} style={{ textAlign: "center", color: "red" }}>
                      No Data Found!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </BoxWrapper>
      )}
    </>
  );
};

export default MSME;
